import { combineReducers } from "redux";
import alert from './alert';
import auth from './auth';
import clients from './clients';
export default combineReducers({
    alert, auth, clients
});